import qs from 'qs';
import { useQuery } from 'react-query';

import { getComponentColumns as queryFn } from 'api/endPoints/getComponentColumns';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetComponentColumns = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getComponentColumns', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.componentId) && Boolean(params.enabled),
    });
};

interface QueryParams {
    componentId?: string;
    enabled?: boolean;
}

interface QueryFnResponse {
    columnOrder: string[];
    hiddenColumns: string[];
}
type QueryResponse = QueryFnResponse & {};
